import { Component, OnInit } from '@angular/core';
import { ObservationGroupService } from 'app/mdm/terminology/observation-group/services/observation-group.service';
import { ObservationGroup } from 'app/mdm/lib/observation-group/observation-group';

@Component({
  selector: 'hw-observation-group-list',
  templateUrl: './observation-group-list.component.html',
})
export class ObservationGroupListComponent implements OnInit {
  public editPrivileges = ['mdm.terminology.edit'];

  public observationGroups: ObservationGroup[];
  public loading: boolean;
  public search: string;

  constructor(private observationGroupService: ObservationGroupService) {}

  public ngOnInit(): void {
    this.loadGroups();
  }

  public loadGroups(): void {
    this.loading = true;
    this.observationGroupService
      .search({ limit: -1 })
      .subscribe((resp) => (this.observationGroups = resp.data))
      .add(() => (this.loading = false));
  }
}
